import * as React from 'react'
import * as iconStyles from '../styles/icon.module.scss'
import { Row, Col } from 'react-bootstrap'
const IconBox = (props) => {
  return (
    <Row>
      <Col xs={12}>
        <img className={iconStyles.icon} src={props.icon} alt='token icon' width={200} />
      </Col>
    </Row>
  )
}

export default IconBox
